import React from 'react';
import { AdSpot } from '@domain-group/fe-co-allhomes-ads';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fluidAdIdPrefix = 'adspot-fluid-pos';
var inlineAdbridgPrefix = 'adb-ah-srp-insearch-';

// Add an inline advertisement after every Nth listing
var insertFluidAds = (listings, _ref) => {
  var adRowStyle = _ref.adRowStyle;
  var newListings = [];
  // Once we ditch the code for the old inline ads, this can become a global const
  var numberOfListingsPerAd = 6;
  listings.forEach((listing, index) => {
    newListings.push(listing);
    if (index % numberOfListingsPerAd === numberOfListingsPerAd - 1) {
      var adIndex = Math.floor(index / numberOfListingsPerAd);
      var adId = "".concat(fluidAdIdPrefix).concat(adIndex + 1);
      var adBridgId = "".concat(inlineAdbridgPrefix).concat(adIndex + 1);
      newListings.push(___EmotionJSX("div", {
        css: adRowStyle,
        key: adBridgId
      }, ___EmotionJSX(AdSpot, {
        gpt: {
          adId,
          strategy: 'window.onload'
        },
        adbridg: {
          id: adBridgId,
          adClass: 'adb-ah-srp-insearch'
        }
      })));
    }
  });
  return newListings;
};
export default insertFluidAds;